import { Box } from "theme-ui";

import { Svg } from "components";

export default function SvgOrImg({ type, src, alt, ...props }) {
  if (src.endsWith(".svg") || type === "svg") {
    return <Svg src={src} aria-label={alt} {...props} />;
  }

  return <Box as="img" src={src} alt={alt} {...props} />;
}
